import React, { createContext, useContext } from "react";

const ProductAccessContext = createContext(null);

export function ProductAccessProvider({ value, children }) {
  return (
    <ProductAccessContext.Provider value={value}>
      {children}
    </ProductAccessContext.Provider>
  );
}

export function useProductAccess() {
  const context = useContext(ProductAccessContext);
  if (!context) {
    throw new Error("useProductAccess must be used inside ProductRoute.");
  }
  return context;
}

